import { InnerSectionContainer } from '../../components/shared/Grid';
import { Root, RootCenter } from './styled';

type Props = {
  children: React.ReactNode;
};

export default function MainCenter({ children }: Props) {
  return (
    <Root>
      <RootCenter>
        <InnerSectionContainer>{children}</InnerSectionContainer>
      </RootCenter>
    </Root>
  );
}
